import colors from '../../colors';
import { Typography } from '../../TSTypes/typography';

const typography: Typography = {
  body: {
    color: colors.primary.darkGrey,
    font: '"IBM Plex Sans", sans-serif',
    fontWeight: '400',
    size: {
      xsm: {
        fontSize: '12px',
      },
      sm: {
        fontSize: '14px',
      },
      md: {
        fontSize: '16px',
      },
    },
  },
  header: {
    type: {
      h1: {
        fontWeight: '600',
        fontSize: '36px',
        color: colors.primary.darkGrey,
      },
      h2: {
        fontWeight: '500',
        fontSize: '30px',
        color: colors.primary.darkGrey,
      },
      h3: {
        fontWeight: '600',
        fontSize: '24px',
        color: colors.primary.darkGrey,
      },
      h4: {
        fontWeight: '500',
        fontSize: '18px',
        color: colors.primary.darkGrey,
      },
    },
  },
};

export default typography;
